/**
 * Per-device preferences (last calendar view, filter). Storage can be unavailable
 * (private mode, blocked site data), so every access is guarded and optional.
 */
export function readPref(key: string): string | null {
  try {
    return window.localStorage.getItem(`kk.${key}`);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string): void {
  try {
    window.localStorage.setItem(`kk.${key}`, value);
  } catch {
    // Not remembering a preference is harmless.
  }
}
